import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, SectionHead } from "../components/ui-bits";
import { useApp } from "../context/AppContext";

const STEPS = [
  { no: "01", title: "Book", desc: "Choose your vehicle and preferred service." },
  { no: "02", title: "We Arrive", desc: "A CARZA service partner reaches your location." },
  { no: "03", title: "Professional Care", desc: "Your vehicle is cleaned using CARZA's standardized process." },
  { no: "04", title: "Drive Clean", desc: "Inspect your vehicle and enjoy a cleaner ride." },
];

export default function HowItWorks() {
  const { openBooking } = useApp();
  return (
    <section id="how" className="light-section relative py-20 lg:py-28" data-testid="how-section">
      <div className="container-x">
        <SectionHead
          eyebrow="How It Works"
          light
          title={<>Book. We Care. You Drive.</>}
          sub="Four steps. No travel, no queues, no guesswork."
          align="center"
        />

        <div className="relative mt-16 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          <div className="pointer-events-none absolute left-0 right-0 top-7 hidden border-t border-dashed border-black/10 lg:block" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.1} className="relative">
              <div className="flex flex-col items-start gap-5" data-testid={`how-step-${s.no}`}>
                <motion.span
                  whileHover={{ rotate: 90, transition: { duration: 0.4 } }}
                  className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border border-carza/40 bg-white font-mono text-sm font-semibold text-carza shadow-[0_10px_30px_-12px_rgba(109,61,245,0.4)]"
                >
                  {s.no}
                </motion.span>
                <div>
                  <h3 className="font-display text-xl font-semibold text-nighttext">{s.title}</h3>
                  <p className="mt-2 max-w-[240px] text-sm leading-relaxed text-[#5c5470]">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14 flex justify-center">
          <button onClick={() => openBooking()} className="btn btn-primary px-8 py-4 text-[15px]" data-testid="how-book-cta">
            Book Your First Service <ArrowRight size={16} />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
